import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "@src/utils/axios/AxiosProvider";
import useZustandStore from "@src/helpers/zustand";
import { LoggerTypes, useKYCAddUserLog } from "@src/api/useKYCAddUserLog";

export interface KYCDataType {
  frameUrl: string;
  skipKycSession: boolean;
  sessionId: string;
}

const apiCall = (apiKey: string) =>
  axiosInstance.post<KYCDataType>(
    "/api/kyc/session/open",
    {},
    {
      headers: {
        "x-api-key": apiKey,
      },
    }
  );

export const useOpenSession = () => {
  const { i18n } = useTranslation();
  const { data: zData, setData } = useZustandStore();
  const navigate = useNavigate();
  const addUserLogMutation = useKYCAddUserLog();

  return useMutation(apiCall, {
    onSuccess(data, apiKey) {
      addUserLogMutation.mutate({ eventName: LoggerTypes.IdentomatStart });
      navigate(`/${i18n.language}/contact`);
      setData({ ...zData, apiKey, identomat: data.data });
    },
    onError(error: any) {
      const response = error?.response;
      if (response?.data?.code === 1722) {
        setData({
          ...zData,
          errorMessage: response.data.displayText || response.data.DisplayText,
        });
        navigate(`/${i18n.language}/incomplete-attempt`);
      } else {
        navigate(`/${i18n.language}/error`);
      }
    },
  });
};
